export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/heifToJpeg.worker.2e8e7241.worker.js");
}
